module.exports = __webpack_public_path__ + "img/panelView_baoSteel_2_3_.2e59d578.png";